import { useTranslation } from "react-i18next";
import { useProductContext } from "~/domains/product/ProductContext";
import { CURRENT_LANGUAGE } from "~/utils/constants";
import { userIsLoggedIn } from "~/domains/user/utils/roles";
import type { TFunction } from "i18next";
import type { ProductData } from "~/domains/product/types/ProductData";

export function useResolveValue(value: string): string {
  const { t } = useTranslation();
  let product = null;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    product = useProductContext();
  } catch {
    // Product is not available - we are not in PDP
  }

  if (value.startsWith("{") && value.endsWith("}")) {
    let result: string | Record<string, unknown> = createContext(product, t);

    const parts = value.substring(1, value.length - 1).split(".");
    for (const part of parts) {
      if (!(result instanceof Object)) {
        break;
      }
      result = result?.[part] as string | Record<string, unknown>;
    }
    return typeof result === "string" ? result : "";
  }

  return value;
}

function createContext(product: ProductData | null, t: TFunction) {
  const languageCode = CURRENT_LANGUAGE.substring(0, 2);
  const context = {
    product: product,
    location: window.location,
    category: {
      name: window.SCHA.meta?.categoryNameEn ?? "",
    },
    currentLanguage: {
      code: languageCode,
      name: t(`languageName.${languageCode}`),
    },
    customer: userIsLoggedIn()
      ? {
          firstName: window.SCHA.user?.firstName ?? "",
          lastName: window.SCHA.user?.lastName ?? "",
          email: window.SCHA.user?.email ?? "",
          industrySector: window.SCHA.user?.industrySector ?? "",
          salutation: window.SCHA.user?.salutationCode ?? "",
        }
      : undefined,
  };
  return context;
}
